const uniqueRoles = children => [...new Set(children.flatMap(item => item.role || []))]

const group = (title, icon, children) => ({
  title,
  icon,
  role: uniqueRoles(children),
  children,
})

const allRoles = [
  'super-admin',
  'admin',
  'administrator',
  'manager-area',
  'president',
  'vice-president',
  'president-director',
  'direksi',
  'operation-director',
  'regional-manager',
  'division-head',
  'fa-coal-manager',
  'finance',
  'laboratory-manager',
  'assistant-lab-manager',
  'manager-lab-cabang',
  'supervisor-cabang',
  'warehouse-cabang',
  'purchasing-cabang',
  'procurement-pusat',
  'inventory-pusat',
  'stock-manager',
  'user',
]

const dashboard = {
  title: 'Dashboard',
  route: 'dashboard',
  icon: 'HomeIcon',
  role: allRoles,
}

const activityLog = {
  title: 'Activity Log',
  route: 'apps-activity-log-list',
  icon: 'ActivityIcon',
  role: allRoles,
}

const administration = [
  {
    title: 'User',
    route: 'apps-users-list',
    icon: 'UserIcon',
    role: ['super-admin', 'admin', 'administrator'],
  },
  {
    title: 'Branches',
    route: 'apps-procurement-branch-list',
    icon: 'ArchiveIcon',
    role: ['super-admin'],
  },
  {
    title: 'Regions',
    route: 'apps-procurement-region-list',
    icon: 'MapIcon',
    role: ['super-admin', 'admin', 'administrator'],
  },
  {
    title: 'Region Branches',
    route: 'apps-procurement-region-branches-list',
    icon: 'MapIcon',
    role: ['super-admin', 'admin', 'administrator'],
  },
  {
    title: 'Departements',
    route: 'apps-procurement-departements-list',
    icon: 'SettingsIcon',
    role: ['super-admin', 'admin', 'administrator'],
  },
  {
    title: 'Roles',
    route: 'apps-roles-list',
    icon: 'ShieldIcon',
    role: ['super-admin'],
  },
  {
    title: 'Units',
    route: 'apps-unit-list',
    icon: 'ArchiveIcon',
    role: ['super-admin', 'admin', 'administrator'],
  },
  {
    title: 'Supplier',
    route: 'apps-supplier-list',
    icon: 'TruckIcon',
    role: ['super-admin', 'admin', 'administrator'],
  },
  {
    title: 'Settings',
    route: 'apps-settings',
    icon: 'SettingsIcon',
    role: ['super-admin'],
  },
  {
    title: 'Error Tickets',
    route: 'apps-tickets-list',
    icon: 'AlertTriangleIcon',
    role: ['super-admin'],
  },
]

const inventoryAssets = [
  {
    title: 'Stock Histories',
    route: 'apps-stocks-list',
    icon: 'TruckIcon',
    role: ['super-admin', 'stock-manager', 'admin', 'administrator', 'warehouse-cabang'],
  },
  {
    title: 'Items',
    route: 'apps-items-list',
    icon: 'FileTextIcon',
    role: ['super-admin', 'warehouse-cabang', 'admin', 'administrator', 'laboratory-manager'],
  },
  {
    title: 'Item Disposals',
    route: 'apps-item-disposals-list',
    icon: 'TrashIcon',
    role: ['super-admin', 'warehouse-cabang', 'admin', 'administrator', 'laboratory-manager'],
  },
  {
    title: 'Assets',
    route: 'apps-procurement-assets-list',
    icon: 'HardDriveIcon',
    role: ['super-admin', 'warehouse-cabang', 'admin', 'administrator', 'laboratory-manager', 'finance', 'division-head', 'fa-coal-manager', 'regional-manager'],
  },
  {
    title: 'Receive Assets',
    route: 'apps-assets-receive-list',
    icon: 'ArrowDownCircleIcon',
    role: ['super-admin', 'admin', 'administrator', 'laboratory-manager', 'finance'],
  },
  {
    title: 'Item Stocks',
    route: 'apps-item-stocks-list',
    icon: 'BoxIcon',
    role: ['super-admin', 'manager-lab-cabang', 'stock-manager', 'warehouse-cabang', 'admin', 'administrator', 'laboratory-manager', 'fa-coal-manager', 'finance'],
  },
]

const procurement = [
  {
    title: 'Material Requests',
    route: 'apps-material-request-list',
    icon: 'ArrowDownCircleIcon',
    role: ['super-admin', 'supervisor-cabang', 'warehouse-cabang', 'user', 'laboratory-manager', 'purchasing-cabang', 'administrator'],
  },
  {
    title: 'Receive MR',
    route: 'apps-material-request-receive-list',
    icon: 'ArrowDownCircleIcon',
    role: ['super-admin', 'user'],
  },
  {
    title: 'PR Plan',
    route: 'apps-procurement-pr-plan-list',
    icon: 'ClipboardIcon',
    role: ['super-admin', 'purchasing-cabang', 'warehouse-cabang', 'laboratory-manager'],
  },
  {
    title: 'Purchase Request',
    route: 'apps-procurement-purchase-request-list',
    icon: 'ArrowDownCircleIcon',
    role: ['super-admin', 'purchasing-cabang', 'laboratory-manager', 'assistant-lab-manager', 'warehouse-cabang', 'regional-manager', 'division-head', 'fa-coal-manager', 'inventory-pusat', 'operation-director', 'vice-president', 'president-director', 'procurement-pusat', 'administrator'],
  },
  {
    title: 'Purchase Order',
    route: 'apps-procurement-purchase-order-list',
    icon: 'ShoppingCartIcon',
    role: ['super-admin', 'purchasing-cabang', 'warehouse-cabang', 'manager-lab-cabang', 'laboratory-manager', 'assistant-lab-manager', 'regional-manager', 'division-head', 'fa-coal-manager', 'inventory-pusat', 'operation-director', 'vice-president', 'president-director', 'procurement-pusat', 'administrator'],
  },
  {
    title: 'Purchase Order Finance',
    route: 'apps-procurement-purchase-order-list-finance',
    icon: 'ShoppingCartIcon',
    role: ['finance', 'fa-coal-manager'],
  },
  {
    title: 'PO Summary',
    route: 'apps-procurement-purchase-order-list-summary',
    icon: 'ShoppingCartIcon',
    role: ['division-head', 'fa-coal-manager', 'operation-director', 'vice-president', 'president-director', 'super-admin'],
  },
  {
    title: 'Purchase Management',
    route: 'apps-procurement-purchase-management-list',
    icon: 'ArchiveIcon',
    role: ['super-admin', 'purchasing-cabang', 'warehouse-cabang', 'manager-lab-cabang', 'laboratory-manager', 'assistant-lab-manager', 'regional-manager', 'division-head', 'fa-coal-manager', 'inventory-pusat', 'operation-director', 'vice-president', 'president-director', 'procurement-pusat', 'administrator'],
  },
  {
    title: 'Direct PR',
    route: 'direct-pr',
    icon: 'DollarSignIcon',
    role: ['super-admin', 'administrator', 'assistant-lab-manager', 'regional-manager', 'division-head', 'fa-coal-manager', 'operation-director', 'vice-president', 'president-director', 'laboratory-manager', 'finance'],
  },
]

const warehouseOperations = [
  {
    title: 'Receive PO Purchasing',
    route: 'apps-purchase-order-pre-receive-purchasing',
    icon: 'ArrowDownCircleIcon',
    role: ['super-admin', 'purchasing-cabang', 'manager-lab-cabang', 'warehouse-cabang', 'laboratory-manager', 'assistant-lab-manager'],
  },
  {
    title: 'Receive PO Warehouse',
    route: 'apps-purchase-order-pre-receive-warehouse',
    icon: 'ArrowDownCircleIcon',
    role: ['super-admin', 'warehouse-cabang', 'laboratory-manager', 'assistant-lab-manager'],
  },
  {
    title: 'Transfers',
    route: 'apps-transfers-list',
    icon: 'CornerUpRightIcon',
    role: ['super-admin', 'warehouse-cabang', 'manager-lab-cabang', 'laboratory-manager', 'assistant-lab-manager', 'regional-manager', 'division-head', 'fa-coal-manager', 'finance'],
  },
  {
    title: 'Returns',
    route: 'apps-returns-list',
    icon: 'TruckIcon',
    role: ['super-admin', 'warehouse-cabang', 'manager-lab-cabang', 'laboratory-manager', 'assistant-lab-manager'],
  },
  {
    title: 'Stock Opname',
    route: 'apps-stock-opname-list',
    icon: 'BookOpenIcon',
    role: ['super-admin', 'finance', 'manager-lab-cabang', 'laboratory-manager', 'assistant-lab-manager', 'administrator'],
  },
  {
    title: 'Void',
    route: 'apps-void',
    icon: 'TrashIcon',
    role: ['super-admin', 'administrator', 'fa-coal-manager'],
  },
]

export default [
  dashboard,
  activityLog,
  {
    title: 'Auditor',
    route: 'apps-auditor',
    icon: 'ClipboardIcon',
    role: ['super-admin', 'finance', 'fa-coal-manager', 'auditor', 'administrator'],
  },
  group('Administration', 'GridIcon', administration),
  group('Inventory & Assets', 'PackageIcon', inventoryAssets),
  group('Procurement', 'BriefcaseIcon', procurement),
  group('Warehouse Operations', 'TruckIcon', warehouseOperations),
]
